export default {
  'component.globalHeader.search': 'ძიება',
  'component.globalHeader.search.example1': 'ძიების მაგალითი 1',
  'component.globalHeader.search.example2': 'ძიების მაგალითი 2',
  'component.globalHeader.search.example3': 'ძიების მაგალითი 3',
  'component.globalHeader.help': 'დახმარება',
  'component.globalHeader.notification': 'შეტყობინება',
  'component.globalHeader.notification.empty': 'თქვენ ყველა შეტყობინება წაიკითხეთ.',
  'component.globalHeader.message': 'მესიჯი',
  'component.globalHeader.message.empty': 'თქვენ ყველა მესიჯი წაიკითხეთ.',
  'component.globalHeader.event': 'მოვლენა',
  'component.globalHeader.event.empty': 'თქვენ ყველა მოვლენა ნახეთ.',
  'component.noticeIcon.clear': 'გასუფთავება',
  'component.noticeIcon.cleared': 'გასუფთავებულია',
  'component.noticeIcon.empty': 'შეტყობინებები არ არის',
  'component.noticeIcon.view-more': 'მეტის ნახვა',
};
